
import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ darkMode, setDarkMode }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.default',
      color: 'text.primary'
    }}>
      <Header 
        darkMode={darkMode} 
        setDarkMode={setDarkMode}
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      
      <Container component="main" sx={{ 
        mt: { xs: 2, sm: 4 }, 
        mb: { xs: 2, sm: 4 }, 
        flex: 1,
        px: { xs: 2, sm: 3, md: 4 }
      }}>
        <Outlet />
      </Container>

      <Footer />
    </Box>
  );
}
